import * as ActionTypes from './actionTypes';

const initialState = {
  createLoading: false,
  giftDetails: null,
  getDetailsLoading: false,
  updateLoading: false,
  deleteLoading: false,
  gifts: { data: [], total: 0 },
  getListLoading: false,
  userGifts: { data: [], total: 0 },
  getUserGiftsLoading: false,
};

export default function gift(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.CREATE_GIFT:
      return {
        ...state,
        createLoading: true,
      };

    case ActionTypes.CREATE_GIFT_SUCCESS:
      return {
        ...state,
        createLoading: false,
      };

    case ActionTypes.CREATE_GIFT_FAILED:
      return {
        ...state,
        createLoading: false,
      };

    case ActionTypes.GET_GIFT_DETAILS:
      return {
        ...state,
        getDetailsLoading: true,
        giftDetails: null,
      };

    case ActionTypes.GET_GIFT_DETAILS_SUCCESS:
      return {
        ...state,
        getDetailsLoading: false,
        giftDetails: action.payload,
      };

    case ActionTypes.GET_GIFT_DETAILS_FAILED:
      return {
        ...state,
        getDetailsLoading: false,
      };

    case ActionTypes.UPDATE_GIFT:
      return {
        ...state,
        updateLoading: true,
      };

    case ActionTypes.UPDATE_GIFT_SUCCESS:
      return {
        ...state,
        updateLoading: false,
      };

    case ActionTypes.UPDATE_GIFT_FAILED:
      return {
        ...state,
        updateLoading: false,
      };

    case ActionTypes.DELETE_GIFT:
      return {
        ...state,
        deleteLoading: true,
      };

    case ActionTypes.DELETE_GIFT_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
      };

    case ActionTypes.DELETE_GIFT_FAILED:
      return {
        ...state,
        deleteLoading: false,
      };

    case ActionTypes.GET_GIFTS:
      return {
        ...state,
        getListLoading: true,
        gifts: { data: [], total: 0 },
      };

    case ActionTypes.GET_GIFTS_SUCCESS:
      return {
        ...state,
        getListLoading: false,
        gifts: action.payload,
      };

    case ActionTypes.GET_GIFTS_FAILED:
      return {
        ...state,
        getListLoading: false,
      };

    case ActionTypes.GET_USER_GIFTS:
      return {
        ...state,
        getUserGiftsLoading: true,
        userGifts: { data: [], total: 0 },
      };

    case ActionTypes.GET_USER_GIFTS_SUCCESS:
      return {
        ...state,
        getUserGiftsLoading: false,
        userGifts: action.payload,
      };

    case ActionTypes.GET_USER_GIFTS_FAILED:
      return {
        ...state,
        getUserGiftsLoading: false,
      };

    default:
      return state;
  }
}
